import { useCallback, useMemo } from 'react'
import {
  ReactFlow,
  Background,
  Controls,
  MiniMap,
  type NodeTypes,
  type Node,
  type Edge,
  applyNodeChanges,
  type NodeChange,
} from '@xyflow/react'
import '@xyflow/react/dist/style.css'
import { useGraphStore } from '../stores/useGraphStore'
import { ObjectNode } from './nodes/ObjectNode'
import type { GraphNodeData } from '../types'

export function CanvasPane() {
  const nodes = useGraphStore((s) => s.nodes)
  const edges = useGraphStore((s) => s.edges)

  const nodeTypes: NodeTypes = useMemo(() => ({ objectNode: ObjectNode }), [])

  const onNodesChange = useCallback((changes: NodeChange[]) => {
    useGraphStore.setState((s) => ({
      nodes: applyNodeChanges(changes, s.nodes) as Node<GraphNodeData>[],
    }))
  }, [])

  return (
    <div className="h-full w-full bg-muted/20">
      <ReactFlow
        nodes={nodes}
        edges={edges as Edge[]}
        nodeTypes={nodeTypes}
        onNodesChange={onNodesChange}
        fitView
        fitViewOptions={{ padding: 0.2, maxZoom: 1 }}
        minZoom={0.2}
        maxZoom={2}
        proOptions={{ hideAttribution: true }}
        nodesConnectable={false}
        elementsSelectable={true}
        defaultEdgeOptions={{ type: 'smoothstep' }}
      >
        <Background gap={24} size={1} color="hsl(0 0% 85%)" />
        <Controls showInteractive={false} className="!shadow-none !border !border-border !rounded-md" />
        <MiniMap
          className="!border !border-border !rounded-md"
          nodeColor={(n) => {
            const data = n.data as GraphNodeData
            return `hsl(${data.hue} 45% 80%)`
          }}
          nodeStrokeWidth={2}
          pannable
          zoomable
        />
      </ReactFlow>
    </div>
  )
}
